module.exports = __webpack_public_path__ + "img/ic_vn.19332699.png";